<template>
  <div>
    <base-info ref="baseInfo" :form="info" />
    <div v-loading="loading" class="rj-page-card">
      <div class="rj-page-card__title">
        合同附件信息
      </div>
      <div class="rj-page-card__content">
        <contract-file :contract-id="num" :is-init="true" :is-show="false" />
      </div>
      <history ref="history" :approve-log-list="approveLogList" />
    </div>
    <product-list
      ref="product"
      :is-test-project="false"
      :product-data="productData"
      :communication-order-discount="1"
      :rebate-amount="info.rebateAmount"
      :sales-type="info.salesType"
      :rebate="info.rebate"
      :contract-id="info.id"
      :form="info"
      @chooseAddress="(val)=>{info.receiptAddressId=val.id}"
    />

    <el-button type="primary" @click="submit">
      发布
    </el-button>
    <el-button v-if="isDisabledReject" type="primary" @click="reject">
      驳回到代理商
    </el-button>
    <!-- <el-button type="primary" @click="save">保存草稿</el-button> -->

    <el-dialog title="驳回意见" :visible.sync="rejectedVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="500" lock-scroll>
      <div>
        <el-input
          v-model="rejectedInfo"
          type="textarea"
          placeholder="请输入您的驳回意见"
          maxlength="200"
          show-word-limit
          rows="6"
        />
      </div>
      <div class="block" style="text-align: right;padding-top: 20px">
        <el-button @click="rejectedVisible=false">
          取 消
        </el-button>
        <el-button type="primary" @click="submitReject">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="es6">
import baseInfo from './baseInfo';
import contractFile from '../../../returnExchange/Chief/commom/file.vue';
import history from '../../../returnExchange/Chief/commom/history.vue';
// import freightInfo from './freightInfo';
// import actions from '../actions';
// import dismissedSuggestion from '../dismissedSuggestion';
import actionMixin from '../actionMixin';
import productList from '../productList';
// import rejectedList from '../rejectedList';
import { orderDetail, cSubmit, orderCancel, detectExportCompliance, createExportComplianceReview } from '@/API';
export default {
  mixins: [actionMixin],
  data () {
    return {
      num: '100219102400304',
      loading: false,
      productLoading: false,
      ishard: true,
      rejectedLoading: false,
      contractId: '',
      email: '',
      baseData: {
        advanceCharge: '',
        prepaymentRatioNum: ''
      },
      flag: false,
      info: {},
      approveLogList: [],
      productData: [],
      rejectedVisible: false,
      rejectedInfo: '',
      // 是否显示签章按钮
      isShowSignature: true
    };
  },
  props: {
    // contractNum: {
    //   type: [String, Number],
    //   required: true
    // }
  },
  components: {
    baseInfo,
    contractFile,
    history,
    productList
    // dismissedSuggestion
    // contractFile,
    // actions,
    // abatementReminder,

    // rejectedList,
    // freightInfo
  },

  computed: {
    isDisabledReject () {
      // 注：r_reason_type 落库值为“产品发运错误”，与“发运错误原因”不相等，
      // 本判断实际不命中。属既有缺陷（非本次改名范围），修复需业务确认后单独处理。
      if (!this.info.rreasonType || this.info.rreasonType === '发运错误原因') return false;
      return true;
    }
  },

  methods: {
    initData () {
      let parmas = { contractId: this.$route.query.contractId, contractType: this.$route.query.contractType };
      orderDetail(parmas).then((res) => {
        this.loading = false;
        let json = res.data;
        if (json.status === '200') {
          this.info = json.data.baseInfoModelVO;
          this.info.rcurrencyType ? this.info.currencyId = this.info.rcurrencyType : this.info.currencyId = 'CNY';
          this.$set(this.info, 'rsetNoticeMail', this.info.businessEmail || '');
          this.$refs.baseInfo.getData(this.info);
          this.approveLogList = json.data.approveLogList;
          this.productData = json.data.addressMOdelVOS;
          this.flag = true;
        }
      }).catch((res) => {
      });
    },
    submit () {
      const postAddressId = this.$refs.product.address && this.$refs.product.address.id;
      if (!postAddressId) {
        this.$message.error('请选择收货地址');
        return;
      }
      let parmas = {
        baseInfo: this.$refs.baseInfo.form,
        postAddressInfoList: [
          {
            proList: this.$refs.product.productList,
            rpostAddressId: postAddressId
          }
        ]
      };
      // 判断 供货单位  订单类型 区域商务专员 不能为空
      if (!parmas.baseInfo.supplyCode) {
        this.$message.error('请选择供货单位');
        return;
      }
      if (!parmas.baseInfo.rpostOrderTypeCode) {
        this.$message.error('请选择订单类型');
        return;
      }
      if (!parmas.baseInfo.rassistantCode) {
        this.$message.error('请选择区域商务专员');
        return;
      }
      // 增加判断 产品型号、期望发货日期、货运属性、料号不可为空
      for (var i = 0; i < this.$refs.product.productList.length; i++) {
        if (this.$refs.product.productList[i].rproductName === '' || this.$refs.product.productList[i].rproductName === null) {
          this.$message.error('请选择产品型号');
          return;
        }
        if (!this.$refs.product.productList[i].rexpectedDeliveryDate || this.$refs.product.productList[i].rexpectedDeliveryDate === '') {
          this.$message.error('请选择期望发货日期');
          return;
        }
        if (!this.$refs.product.productList[i].rfreightProperties || this.$refs.product.productList[i].rfreightProperties === '') {
          this.$message.error('请选择货运属性');
          return;
        }
        if (this.$refs.product.productList[i].rmaterialNum === '' || !this.$refs.product.productList[i].rmaterialNum) {
          this.$message.error('请选择料号');
          return;
        }
      }

      detectExportCompliance(parmas).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.handleComplianceResult(parmas, json.data);
        }
      }).catch(() => {

      });
    },
    handleComplianceResult (parmas, result) {
      if (!result || !result.overallRiskLevel || result.overallRiskLevel <= 2) {
        this.publishOrder(parmas);
        return;
      }

      const reviewInfo = result.reviewInfo;
      if (result.duplicate && reviewInfo && reviewInfo.hasReview) {
        if (reviewInfo.handleResult === 1) {
          this.publishOrder(parmas);
          return;
        }
        const reviewStatus = reviewInfo.handleStatusDesc || reviewInfo.handleResultDesc || '尚未通过';
        const messageContent = this.$createElement('div', [
          this.$createElement('div', `该请求已存在合规审查单（${reviewInfo.interceptNo || '-'}），当前状态：${reviewStatus}，暂不能发布。`),
          result.complianceContactMsg ? this.$createElement('div', { style: { marginTop: '8px' } }, result.complianceContactMsg) : null
        ].filter(Boolean));
        this.$alert(messageContent, '合规审查提示', {
          confirmButtonText: '确定',
          type: 'warning'
        });
        return;
      }

      const message = result.resultMsg || result.overallConclusion || '检测到出口合规风险。';
      const messageContent = this.$createElement('div', [
        this.$createElement('div', message),
        result.detailMsg ? this.$createElement('div', { style: { marginTop: '8px' } }, result.detailMsg) : null,
        result.complianceContactMsg ? this.$createElement('div', { style: { marginTop: '8px' } }, result.complianceContactMsg) : null,
        this.$createElement('div', { style: { marginTop: '8px' } }, '是否创建审查单？')
      ].filter(Boolean));
      this.$confirm(messageContent, '出口合规风险提示', {
        confirmButtonText: '确定并创建审查单',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        createExportComplianceReview(parmas).then((res) => {
          const json = res.data;
          if (json.status === '200') {
            const promptMessage = json.data && json.data.promptMessage;
            this.$message.success(promptMessage ? `${promptMessage}` : '审查单创建成功，请等待审查通过后重新发布');
          }
        });
      }).catch(() => {});
    },
    publishOrder (parmas) {
      cSubmit(parmas).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$message.success('提交成功');
          this.$router.replace({ name: 'orderPersionContractList' });
        }
      });
    },
    submitReject () {
      let parmas = {
        contractId: this.info.contractId,
        contractNum: this.info.rnewContractNum,
        action: 'reject',
        remarks: this.rejectedInfo
      };
      orderCancel(parmas).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$message.success('驳回成功');
          this.$router.push({ name: 'orderPersionContractList' });
        }
      }).catch((error) => {
        this.$message.error('驳回失败！', error);
      });
    },
    save () {
      let parmas = {
        baseInfo: { ...this.$refs.baseInfo.form, risDraft: true },
        postAddressInfoList: [
          {
            proList: this.$refs.product.productList,
            rpostAddressId: this.$refs.product.address.id
          }
        ]
      };
      // 判断 供货单位  订单类型 区域商务专员 不能为空
      if (!parmas.baseInfo.supplyCode) {
        this.$message.error('请选择供货单位');
        return;
      }
      if (!parmas.baseInfo.rpostOrderTypeCode) {
        this.$message.error('请选择订单类型');
        return;
      }
      if (!parmas.baseInfo.rassistantCode) {
        this.$message.error('请选择区域商务专员');
        return;
      }
      // 增加判断 产品型号、期望发货日期、货运属性、料号不可为空
      for (var i = 0; i < this.$refs.product.productList.length; i++) {
        if (this.$refs.product.productList[i].rproductName === '' || this.$refs.product.productList[i].rproductName === null) {
          this.$message.error('请选择产品型号');
          return;
        }
        if (this.$refs.product.productList[i].rexpectedDeliveryDate === null || this.$refs.product.productList[i].rexpectedDeliveryDate === '') {
          this.$message.error('请选择期望发货日期');
          return;
        }
        if (this.$refs.product.productList[i].rfreightProperties === null || this.$refs.product.productList[i].rfreightProperties === '') {
          this.$message.error('请选择货运属性');
          return;
        }
        if (this.$refs.product.productList[i].rmaterialNum === '' || this.$refs.product.productList[i].rmaterialNum === null) {
          this.$message.error('请选择料号');
          return;
        }
      }

      cSubmit(parmas).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$message.success('提交成功');
          this.$router.replace({ name: 'orderPersionContractList' });
        }
      }).catch(() => {

      });
    },
    reject () {
      this.rejectedVisible = true;
    }
  },
  mounted () {
    this.initData();
  },
  watch: {

  }
};
</script>
<style>
  .rj-page-card:nth-of-type(3){
    margin-bottom: 0;
    padding-bottom: 0;
    overflow: hidden;
  }
</style>
